import http from '../http'
export default {
	//查询菜单列表
	getMenu: (params = {}) => http.post('/api2/front/menu/selectList', params),
	//查询参数配置列表
	getParams: (params = {}) => http.post('/api2/front/params/selectList', params),
	//查询分类列表
	getClazz: (params = {}) => http.post('/api2/front/clazz/selectList', params),
	//查询分类数据
	getPage: (params = {}) => http.post('/api2/front/page/selectListByPage', params),
	//查询页面详情
	selectInfo: (params = {}) => http.post('/api2/front/page/selectInfo', params),
}
